"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SANDBOX_PROP = exports.MOBILE_MEDIA_QUERY = exports.DEVICE_TYPE = exports.ON_CLOSE = exports.CLOSE_BUTTON_URL = exports.DEFAULT_QUERY_PARAMS = exports.URL_QUERY_PARAMS = exports.RESPONSIVE_STYLES = exports.STYLES = exports.DEFAULT_LOGIN_URL = void 0;
exports.DEFAULT_LOGIN_URL = '/authn/v1/signin';
exports.STYLES = {
    overlay: {
        id: 'auth-login-overlay',
        zIndex: '999',
        width: '100vw',
        height: '100vh',
        position: 'fixed',
        top: 0,
        left: 0,
        background: 'rgba(46, 46, 51, 0.66)',
    },
    wrapper: {
        position: 'fixed',
        zIndex: '1000',
        transition: 'all 0.5s ease-in-out',
        background: 'white',
        id: 'auth-login-wrapper',
    },
    iframe: {
        width: '100%',
        height: '100%',
        border: 'none',
        borderRadius: 'inherit',
    },
    closeButton: {
        position: 'absolute',
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        fontWeight: '300',
    },
    closeIcon: {
        width: '24px',
        height: '24px',
    },
};
exports.RESPONSIVE_STYLES = {
    MOBILE: {
        WRAPPER: {
            width: '100%',
            height: '272px',
            bottom: '-100%',
            right: '0',
            transform: 'none',
            borderRadius: '20px 20px 0 0',
        },
        CLOSE_ICON: {
            top: '24px',
            right: '20px',
        },
    },
    DESKTOP: {
        WRAPPER: {
            height: '328px',
            width: '560px',
            top: '50%',
            right: '50%',
            transform: 'translate(50%, -50%)',
            borderRadius: '20px',
        },
        CLOSE_ICON: {
            top: '32px',
            right: '32px',
        },
    },
};
exports.URL_QUERY_PARAMS = {
    SCREEN: 'screen',
    IFRAME: 'iframe',
    MOBILE: 'mobile',
    CLIENT_ID: 'client_id',
    STATE: 'state',
    CUSTOM_EDIT: 'custom-edit',
    DEVICE_TYPE: 'device'
};
exports.DEFAULT_QUERY_PARAMS = {
    [exports.URL_QUERY_PARAMS.STATE]: '/authn/login-success',
    [exports.URL_QUERY_PARAMS.IFRAME]: 'true',
    [exports.URL_QUERY_PARAMS.SCREEN]: 'otp',
    [exports.URL_QUERY_PARAMS.CUSTOM_EDIT]: 'true',
};
exports.CLOSE_BUTTON_URL = 'https://acko-cms.ackoassets.com/Close_b4960d98e5.svg';
exports.ON_CLOSE = 'on_close';
exports.DEVICE_TYPE = {
    MOBILE: 'mobile',
    DESKTOP: 'desktop',
};
exports.MOBILE_MEDIA_QUERY = '(max-width: 768px)';
exports.SANDBOX_PROP = 'allow-scripts allow-same-origin allow-forms';
//# sourceMappingURL=constants.js.map